import Navbar from "@components/common/Navbar";
import Footer from "@components/common/Footer";
import { Container } from "@chakra-ui/react";

const PageLayout = ({ children }) => (
  <>
    <Navbar />
    <Container
      maxW="7xl"
      pt={{ base: 2, lg: 28 }}
      px={{ base: 4, md: 2, lg: 0 }}
      children={children}
    />
    <Footer />
  </>
);

export default PageLayout;
